<template>
  <v-card-text>
    <v-form >
      <v-text-field
        autofocus
        v-model='dataModel[modifyIndex].name'
        :label="`First name of your ${relativeName}`"></v-text-field>

      <AgeQuestRel
        :data="dataModel"
        :modifyIndex="modifyIndex"/>

      <GenderQuest
        :modifyData="dataModel"
        :modifyIndex="modifyIndex"/>

      <div
        v-if='["niece/nephew", "paternal cousin", "maternal cousin", "grandchild", "great grandchild"].includes(dataModel[modifyIndex].relationship)'>
        <span>Who is this person's father or mother?</span>

        <v-select
          placeholder="Parents of this person"
          v-model="dataModel[modifyIndex].parents"
          :items="parentsList()"
          required></v-select>
      </div>

      <HalfSib
        v-if="halfSibCheck()"
        :modifyData="dataModel"
        :modifyIndex="modifyIndex"/>

      <DeathQuest
        :data="dataModel"
        :modifyIndex="modifyIndex"/>

      <AddtionalQuestion  :data="dataModel"
        :modifyIndex="modifyIndex" />

      <span><v-icon
      slot="icon"
      color="blue"
      size="25"
    >
      info
    </v-icon>Please add any health conditions that this person has or has had that you are aware of. Provide as much information as you can, and don’t worry if there are some details missing.</span>
      <CondTest
        :modifyData="dataModel"
        :modifyIndex="modifyIndex"/>

      <v-textarea
        v-model="dataModel[modifyIndex].notes"
        outline
        name="input-7-4"
        label="Comments"
        value=""></v-textarea>

    </v-form>
  </v-card-text>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import AddtionalQuestion from "./additonalQuest"
import AgeQuestRel from "./AgeQuestRel";
import GenderQuest from "./GenderQuest";
import CondTest from "./CondTest";
import DeathQuest from "./DeathQuest";
import HalfSib from "./HalfSib";

export default {
  props: {
    relativeName: String,
    modifyIndex: Number,
    formType: Array
  },
  components: {
    AddtionalQuestion,
    GenderQuest,
    AgeQuestRel,
    DeathQuest,
    CondTest,
    HalfSib
  },
  mounted () {
  },
  data: () => ({
    ageRules: [v => (v && v >= 0) || 'Age must be larger or equal to 0'],
    imediates: [
      "self",
      "mother",
      "father",
      "maternal grandfather",
      "maternal grandmother",
      "paternal grandfather",
      "paternal grandmother",
    ],
  }),
  methods: {
    halfSibCheck(){
      if(this.dataModel[this.modifyIndex].relationship === "sibling") {
        return true;
      }
      else {
        return false;
      }
    },
    ageText () {
      if (this.dataModel[this.modifyIndex].isLiving) {
        if (this.dataModel[this.modifyIndex].name == "") {
          return 'What is ' + this.formType[0] + " " + this.relativeName + '\'s age?'
        }
        return 'What is ' + this.dataModel[this.modifyIndex].name + '\'s age?'
      }
      else {
        if (this.dataModel[this.modifyIndex].name == "") {
          return 'What is ' + this.formType[0] + " " + this.relativeName + '\'s age of passing?'
        }
        return 'What is ' + this.dataModel[this.modifyIndex].name + '\'s age of passing?'
      }
    },
    parentsList () {
      let pList
      switch (this.dataModel[this.modifyIndex].relationship) {
        case "great grandchild":
          pList = this.dataModel.filter(item => {
            return item.relationship === "grandchild"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "grandchild":
          pList = this.dataModel.filter(item => {
            return item.relationship === "child"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "paternal cousin":
          pList = this.dataModel.filter(item => {
            return item.relationship === "paternal uncle" || item.relationship === "paternal aunt"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "maternal cousin":
          pList = this.dataModel.filter(item => {
            return item.relationship === "maternal uncle" || item.relationship === "maternal aunt"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "niece/nephew":
          pList = this.dataModel.filter(item => {
            return item.relationship === "sibling"
          }).map(function (obj) {
            return obj.name
          });
          return pList
      }
    },
  },
  computed: {
    ...mapFields('patientQuestion', [
      'dataModel', 
    ])
  }
}
</script>
